import ACTIONS from "../constants";

export const sendVertex360CopilotMessage = {
  pending: () => ({ type: ACTIONS.VERTEX360_COPILOT_SEND_MESSAGE.PENDING }),
  success: () => ({ type: ACTIONS.VERTEX360_COPILOT_SEND_MESSAGE.SUCCESS }),
  error: (error) => ({
    type: ACTIONS.VERTEX360_COPILOT_SEND_MESSAGE.ERROR,
    error,
  }),
};

export const sendVertex360CopilotMessageRequest = (text, options = {}) => ({
  type: ACTIONS.VERTEX360_COPILOT_SEND_MESSAGE_CALL,
  payload: {
    text,
    ...(options?.clarifyMessageId ||
    options?.clarifySelectedOption ||
    options?.clarifyAnswers
      ? {
          clarify: {
            clarifyMessageId: options.clarifyMessageId,
            clarifySelectedOption: options.clarifySelectedOption,
            clarifySelectedLabel: options.clarifySelectedLabel,
            clarifyAnswers: options.clarifyAnswers,
          },
        }
      : options?.clarify
        ? { clarify: options.clarify }
        : {}),
    ...(options?.clearActiveFilters ? { clearActiveFilters: true } : {}),
  },
});

export const loadVertex360CopilotOlderMessages = {
  pending: () => ({
    type: ACTIONS.VERTEX360_COPILOT_LOAD_OLDER_MESSAGES.PENDING,
  }),
  success: () => ({
    type: ACTIONS.VERTEX360_COPILOT_LOAD_OLDER_MESSAGES.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.VERTEX360_COPILOT_LOAD_OLDER_MESSAGES.ERROR,
    error,
  }),
};

export const loadVertex360CopilotOlderMessagesRequest = () => ({
  type: ACTIONS.VERTEX360_COPILOT_LOAD_OLDER_MESSAGES_CALL,
});

export const appendVertex360CopilotMessage = (message) => ({
  type: ACTIONS.VERTEX360_COPILOT_APPEND_MESSAGE,
  payload: message,
});

export const prependVertex360CopilotMessages = (messages) => ({
  type: ACTIONS.VERTEX360_COPILOT_PREPEND_MESSAGES,
  payload: messages,
});

export const updateVertex360CopilotMessageContent = (id, content, options = {}) => ({
  type: ACTIONS.VERTEX360_COPILOT_UPDATE_MESSAGE_CONTENT,
  payload: {
    id,
    content,
    ...(options.isError !== undefined ? { isError: Boolean(options.isError) } : {}),
  },
});

export const rekeyVertex360CopilotMessage = (fromId, toId) => ({
  type: ACTIONS.VERTEX360_COPILOT_REKEY_MESSAGE,
  payload: { fromId, toId },
});

export const setVertex360CopilotMessageRender = (
  id,
  {
    render,
    sources,
    suggestions,
    isReducedMode,
    degradeReason,
    servicePath,
  } = {}
) => ({
  type: ACTIONS.VERTEX360_COPILOT_SET_MESSAGE_RENDER,
  payload: {
    id,
    ...(render !== undefined ? { render } : {}),
    ...(sources !== undefined ? { sources } : {}),
    ...(suggestions !== undefined ? { suggestions } : {}),
    ...(isReducedMode !== undefined ? { isReducedMode } : {}),
    ...(degradeReason !== undefined ? { degradeReason } : {}),
    ...(servicePath !== undefined ? { servicePath } : {}),
  },
});

export const setVertex360CopilotMessageFeedback = (id, feedbackRating) => ({
  type: ACTIONS.VERTEX360_COPILOT_SET_MESSAGE_FEEDBACK,
  payload: { id, feedbackRating },
});

export const setVertex360CopilotTyping = (isAssistantTyping) => ({
  type: ACTIONS.VERTEX360_COPILOT_SET_TYPING,
  payload: { isAssistantTyping },
});

export const setVertex360CopilotStreaming = (payload) => ({
  type: ACTIONS.VERTEX360_COPILOT_SET_STREAMING,
  payload,
});

export const setVertex360CopilotOlderPagination = (payload) => ({
  type: ACTIONS.VERTEX360_COPILOT_SET_OLDER_PAGINATION,
  payload,
});

export const setVertex360CopilotMessagesPageSize = (pageSize) => ({
  type: ACTIONS.VERTEX360_COPILOT_SET_MESSAGES_PAGE_SIZE,
  payload: { pageSize },
});

export const setVertex360CopilotConversationId = (conversationId) => ({
  type: ACTIONS.VERTEX360_COPILOT_SET_CONVERSATION_ID,
  payload: { conversationId },
});

export const setVertex360CopilotActiveFilters = ({
  activeFilters = null,
  contextSummary = null,
} = {}) => ({
  type: ACTIONS.VERTEX360_COPILOT_SET_ACTIVE_FILTERS,
  payload: { activeFilters, contextSummary },
});

export const resetVertex360CopilotConversation = () => ({
  type: ACTIONS.VERTEX360_COPILOT_RESET_CONVERSATION,
});

export const stopVertex360CopilotGeneration = () => ({
  type: ACTIONS.VERTEX360_COPILOT_STOP_GENERATION,
});

export const removeVertex360CopilotMessage = (id) => ({
  type: ACTIONS.VERTEX360_COPILOT_REMOVE_MESSAGE,
  payload: { id },
});

export const retryVertex360CopilotMessageRequest = (text) => ({
  type: ACTIONS.VERTEX360_COPILOT_RETRY_MESSAGE_CALL,
  payload: { text },
});
